import getVisibilityArchivalState from './get-visibility-archival-state';

export default namespaceSettings =>
  getVisibilityArchivalState(namespaceSettings) === 'Enabled';



// WEBPACK FOOTER //
// ./client/routes/namespace/workflow-archival/helpers/is-visibility-archival-enabled.js